$(document).ready(function(){
      // var devProductPriceValue = $('.product__price span[dataPriceIncrement="50"]').text();
      // devProductPriceValue = devProductPriceValue[1];
      // console.log(devProductPriceValue);
      // value = '$50';     
      // var answer = parseInt(devProductPriceValue) + parseInt(value);
      // $('.product__price span[dataPriceIncrement="50"]').text(answer);

    $(document).on('click', '.product__page [data-popout-option]', function (e) {
      e.preventDefault();
    
      var $option = $(this);
      var $popout = $option.closest('.select-popout');
      var $toggleText = $popout.find('[data-popout-toggle-text]');
      var $input = $popout.find('[data-popout-input]');
    
      var fullText = $option.find('span').text().trim();
    
      $toggleText.text(fullText);
    
      var selectedValue = $option.data('value');
      $input.val(selectedValue);
    
      $popout.find('.select-popout__item').removeClass('is-active');
      $option.closest('li').addClass('is-active');
    });  
});


// Shopify format money helper function
(function () {
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision ?? 2;
    thousands = thousands ?? ",";
    decimal   = decimal ?? ".";

    if (isNaN(number) || number === null) return "0";

    const fixed = (number / 100).toFixed(precision);
    const parts = fixed.split(".");
    const dollars = parts[0].replace(
      /\B(?=(\d{3})+(?!\d))/g,
      thousands
    );
    const cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  window.Shopify = window.Shopify || {};

  window.Shopify.formatMoney = function (cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || theme.moneyFormat || "$";

    function formatValue(match, placeholder) {
      switch (placeholder) {
        case "amount":
          return formatWithDelimiters(cents, 2);

        case "amount_no_decimals":
          return formatWithDelimiters(cents, 0);

        case "amount_with_comma_separator":
          return formatWithDelimiters(cents, 2, ".", ",");

        case "amount_with_space_separator":
          return formatWithDelimiters(cents, 2, " ", ".");

        case "amount_with_apostrophe_separator":
          return formatWithDelimiters(cents, 2, "'", ".");

        default:
          return formatWithDelimiters(cents, 2);
      }
    }

    return formatString.replace(placeholderRegex, formatValue);
  };
})();


// zepto pplr price update
// Only the product's own price (main + sticky bar), never the product cards in
// "You might also like" / "Recently viewed" / Seen on you rows (a1631).
var PPLR_PRICE_SELECTOR = '[data-product-price]:not([data-grid-item] [data-product-price])';

function pplrPriceUpdate() {
 if(Shopify && typeof Shopify.formatMoney === 'function') {
    const productPriceElms = document.querySelectorAll(PPLR_PRICE_SELECTOR);
    if(!productPriceElms.length || typeof pplr_product === 'undefined') {
      productPriceElms?.forEach(elm => elm.classList.remove('hidden')); // if pplr failed then show product price
      return;
    };

    let totalCents = 0;

    function calcPPLRPrices() {
      totalCents = 0;
      // Calculate total cents of inputs
      document.querySelectorAll('.pplr_text[data-pplr_price]').forEach(elm => {
        let price = parseFloat(elm.dataset.pplr_price) || 0;

        // convert to cents
        let cents = Math.round(price * 100);
        totalCents += cents;
      });

      // Calculate total cents of select
      document.querySelectorAll('.pplr_select').forEach(elm => {
        let price = parseFloat(elm[elm.selectedIndex].dataset.pplr_price) || 0;

        // convert to cents
        let cents = Math.round(price * 100);
        totalCents += cents;
      })
    }
    
    function updateMainPrice() {
      calcPPLRPrices();
      productPriceElms.forEach(elm => {
        elm.innerHTML = Shopify.formatMoney((pplr_product.price + totalCents), theme.moneyFormat);
        elm.classList.remove('hidden');
        elm.setAttribute('data-pplr-main-price', Shopify.formatMoney((pplr_product.price + totalCents), theme.moneyFormat));
      })
    }
    updateMainPrice();

    // For empty input value set it to default price
    document.querySelectorAll('.pplr_text[data-pplr_price]')?.forEach(elm => {
      elm.addEventListener('input', () => {
        if (elm.value.length === 0) {
          productPriceElms.forEach(priceElm => priceElm.classList.add('hidden'));
          setTimeout(() => {
            updateMainPrice();
          }, 400);
        }
      })
    })


    // Update prices when select value changes and all text inputs have no letters
    document.querySelectorAll('.pplr_select')?.forEach(elm => {
      elm.addEventListener('change', () => {
        if(productPriceElms.length && Array.from(document.querySelectorAll('.pplr_text[data-pplr_price]')).every(elm => elm.value.length === 0)) {
          productPriceElms.forEach(priceElm => priceElm.classList.add('hidden'));
          setTimeout(() => {
            updateMainPrice();
          }, 400);
        }
      })
    })
  }
}

window.addEventListener('pplrAppInitiated' , function() {
 pplrPriceUpdate();

  // On pplr swatch click - update prices
  document.querySelectorAll('.pplr-swatch-element')?.forEach(elm => {
    const productPriceElms = document.querySelectorAll(PPLR_PRICE_SELECTOR);
    elm.addEventListener('click', () => {
      const isInputsEmtpy = [...document.querySelectorAll('.pplr_text')].every(elm => elm.value.length === 0);
      if(isInputsEmtpy) {
        productPriceElms?.forEach(priceElm => {
          if(priceElm.hasAttribute('data-pplr-main-price')) priceElm.innerHTML = priceElm.getAttribute('data-pplr-main-price');
        })
      }
    })
  })
})

// If no zepto pplr product options then show product prices
document.addEventListener('DOMContentLoaded', () => {
  if(typeof pplr_product === 'undefined') {
    const productPriceElms = document.querySelectorAll('[data-product-price]');
    if(!productPriceElms.length || typeof pplr_product === 'undefined') {
      // if price elements exists then remove hidden class
      productPriceElms?.forEach(elm => elm.classList.remove('hidden'));
    };
  }
})


/* ------------------------------------------------------------------
   Accessibility: keyboard support for the custom "hc-" variant
   dropdown (jewelry length/size picker on sold-outs products).

   The visible control is built from <div>s and the existing click
   handlers (in the theme layouts) do the actual variant selection.
   This block ONLY layers keyboard operation and ARIA state on top of
   those handlers — it does not replace them:
     - hc-selected (role="button"): Enter/Space/ArrowDown to open,
       focus moves into the option list.
     - hc-option (role="option"): Up/Down/Home/End to move, Enter/Space
       to select, Escape to close and return focus to the toggle.
   ------------------------------------------------------------------ */
(function () {
  var isOpen = function (menu) {
    return !!menu && window.getComputedStyle(menu).display !== 'none';
  };

  // Reflect open/closed and selected state for assistive tech after any
  // interaction (mouse or keyboard).
  var syncHcState = function () {
    document.querySelectorAll('.hc-custom-wrapper').forEach(function (wrapper) {
      var toggle = wrapper.querySelector('.hc-selected');
      var menu = wrapper.querySelector('.hc-items-wrapper');
      if (toggle && menu) {
        toggle.setAttribute('aria-expanded', isOpen(menu) ? 'true' : 'false');
      }
      wrapper.querySelectorAll('.hc-option').forEach(function (opt) {
        opt.setAttribute('aria-selected', opt.classList.contains('selected') ? 'true' : 'false');
      });
    });
  };

  document.addEventListener('click', function () { setTimeout(syncHcState, 0); });
  document.addEventListener('DOMContentLoaded', function () { setTimeout(syncHcState, 0); });

  document.addEventListener('keydown', function (e) {
    if (!e.target || !e.target.closest) return;

    var toggle = e.target.closest('.hc-selected');
    if (toggle) {
      var wrapper = toggle.closest('.hc-custom-wrapper');
      var menu = wrapper && wrapper.querySelector('.hc-items-wrapper');
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        toggle.click(); // existing handler toggles the list
        setTimeout(function () {
          syncHcState();
          if (isOpen(menu)) {
            var first = menu.querySelector('.hc-option');
            if (first) first.focus();
          }
        }, 0);
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (!isOpen(menu)) toggle.click();
        setTimeout(function () {
          syncHcState();
          var first = menu && menu.querySelector('.hc-option');
          if (first) first.focus();
        }, 0);
      }
      return;
    }

    var option = e.target.closest('.hc-option');
    if (option) {
      var wrap = option.closest('.hc-custom-wrapper');
      var tog = wrap && wrap.querySelector('.hc-selected');
      var list = wrap && wrap.querySelector('.hc-items-wrapper');
      var options = wrap ? Array.prototype.slice.call(wrap.querySelectorAll('.hc-option')) : [];
      var idx = options.indexOf(option);

      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        option.click(); // existing handler selects the variant + closes
        setTimeout(function () { syncHcState(); if (tog) tog.focus(); }, 0);
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (idx < options.length - 1) options[idx + 1].focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (idx > 0) options[idx - 1].focus();
      } else if (e.key === 'Home') {
        e.preventDefault();
        if (options[0]) options[0].focus();
      } else if (e.key === 'End') {
        e.preventDefault();
        if (options.length) options[options.length - 1].focus();
      } else if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        if (list) list.style.display = 'none';
        syncHcState();
        if (tog) tog.focus();
      }
    }
  });
})();